// src/components/ToolRouteHandler.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ToolRouteHandler = () => {
  const { toolPath } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // This component now simply redirects from the old /tools/:toolPath format
    // to the new, cleaner /:toolPath format.
    navigate(`/${toolPath}`, { replace: true });
  }, [toolPath, navigate]);

  return null;
};

export default ToolRouteHandler;
